<template>
  <div
    :class="{ 'pagination-outside': placePaginationOutside, 'arrows-outside': placeArrowsOutside }"
    class="a-carousel"
  >
    <template v-if="carouselIsRegistered">
      <div
        v-if="placeArrowsOutside && !hideArrows"
        class="swiper-arrows"
      >
        <div
          class="swiper-arrow swiper-button-prev"
          @click="runSwiperFunc('slidePrev')"
        >
          <div class="icon-container">
            <ChevronLeft/>
          </div>
        </div>
        <div
          class="swiper-arrow swiper-button-next"
          @click="runSwiperFunc('slideNext')"
        >
          <div class="icon-container">
            <ChevronRight/>
          </div>
        </div>
      </div>
      <swiper
        :options="carouselOptions"
        :key="swiperKey"
        ref="swiper"
      >
        <slot/>
        <div
          v-if="!hidePagination"
          class="swiper-pagination"
          slot="pagination"
        />
        <template v-if="!placeArrowsOutside && !hideArrows">
          <div
            class="swiper-arrow swiper-button-prev"
            slot="button-prev"
          >
            <div class="icon-container">
              <ChevronLeft/>
            </div>
          </div>
          <div
            class="swiper-arrow swiper-button-next"
            slot="button-next"
          >
            <div class="icon-container">
              <ChevronRight/>
            </div>
          </div>
        </template>
      </swiper>
    </template>
    <div
      v-else
      class="ssr-mode swiper-container"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
import merge from 'lodash/merge'
import { v4 as uuidv4 } from 'uuid'
import ChevronLeft from './ChevronLeft'
import ChevronRight from './ChevronRight'

export default {
  name: 'ACarousel',
  components: {
    ChevronLeft,
    ChevronRight
  },
  props: {
    placeArrowsOutside: {
      type: Boolean,
      required: false,
      default: false
    },
    placePaginationOutside: {
      type: Boolean,
      required: false,
      default: false
    },
    hidePagination: {
      type: Boolean,
      required: false,
      default: false
    },
    hideArrows: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      carouselOptions: {},
      swiperKey: null,
    }
  },
  created() {
    this.setOptions()
  },
  computed: {
    swiper() {
      if (this.$refs && this.$refs.swiper) {
        return this.$refs.swiper
      }
      return null
    },
    swiperInstance() {
      if (this.swiper && this.swiper.swiper) {
        return this.swiper.swiper
      }
      return null
    },
    carouselIsRegistered() {
      return this.$options.components['swiper'] != null
    },
  },
  methods: {
    setOptions() {
      const defaultSettings = {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: false,
        on: {
          // slideChangeTransitionEnd () {
          //   this.loopDestroy();
          //   this.loopCreate();
          // }
        },
      }

      let settings =  merge({}, defaultSettings, this.options)

      if (this.hidePagination) {
        settings.pagination = false
      } else {
        settings.pagination = {
          el: '.swiper-pagination',
          clickable: true
        }
      }

      if (this.hideArrows) {
        settings.navigation = false
      } else {
        if (!this.placeArrowsOutside) {
          settings.navigation = {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }
        }
      }

      // TEMP: disable looping
      settings.loop = false

      this.$set(this, 'carouselOptions', settings)
      this.swiperKey = uuidv4()
    },
    runSwiperFunc(name, args=[]) {
      if (this.swiperInstance && this.swiperInstance[name] && typeof this.swiperInstance[name] === 'function') {
        this.swiperInstance[name](...args)
      }
    },
  },
  watch: {
    options: {
      handler(val) {
        this.setOptions()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
@import '~swiper/dist/css/swiper.css';
@import '~@scss/custom.scss';

// legacy
$swiper-bullet-size: 1.1rem !default;
$swiper-bullet-active-color: #ffffff !default;
$swiper-bullet-color: #ffffff !default;

.a-carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &.arrows-outside {
    .swiper-arrows {
      opacity: 0;
      @include transition (opacity .3s);
      z-index: 2;
        @include media-breakpoint-down(md) {
        display:none;
      }
    }
    @include hover-focus {
      .swiper-arrows {
        opacity: 1;
      }
    }
  }
  &:not(.arrows-outside) {
    .swiper-arrow {
      opacity: 0;
    }
    @include hover-focus {
      .swiper-arrow {
        opacity: 1;
      }
    }
    @include media-breakpoint-down(md) {
      .swiper-arrow {
      display: none;
    }
    }

    .swiper-arrow {
      @include transition ((transform .3s, opacity .3s));
      transform: scale(1, 1);
      @include hover-focus {
      transform: scale(1.2, 1.2);
      }
    }
  }

  @include hover-focus {
  .swiper-icon-navigation {
      opacity: 1;
    }
  }

  // reset arrow styling
  .swiper-arrow {
    background-image: none;
    top: 50%;
    width: auto;
    height: auto;
    margin-top: -2em;
    cursor: pointer;
    outline: none;
    z-index: 2;
    position: absolute;
    .icon-container {
      padding: 1em;
      border-radius: 100%;
      width: 4em;
      height: 4em;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      line-height: 1;
      svg {
        width: 3em;
        height: 3em;
        path {
          fill: #ffffff;
        }
      }
    }
    &.swiper-button-disabled {
      color: var(--main-content-carousel-arrow-default-color);
      .icon-container {
        svg {
          path {
            fill: var(--main-content-carousel-arrow-default-color);
          }
        }
      }
      cursor:not-allowed;
    }
  }

  &.arrows-outside {
    .swiper-arrow {
      .icon-container {
        padding: 1em;
        width: 3em;
        height: 3em;
      }
      margin-top: -1.5em;
    }
    .swiper-arrow {
      color: var(--main-content-carousel-arrow-active-color);
      .icon-container {
        svg {
          path {
            fill: var(--main-content-carousel-arrow-active-color);
          }
        }
      }
      &.swiper-button-disabled {
        color: var(--main-content-carousel-arrow-default-color);
        .icon-container {
          svg {
            path {
              fill: var(--main-content-carousel-arrow-default-color);
            }
          }
        }
      }
    }
    .swiper-button-prev {
      left: -4em;
    }

    .swiper-button-next {
      right: -4em;
    }
  }
  &:not(.arrows-outside) {
    .swiper-button-prev {
      left: 1.5em;
    }
    .swiper-button-next {
      right: 1.5em;
    }
  }
  &.pagination-outside {
    .swiper-pagination-bullet {
      opacity:1;
      background: var(--main-content-carousel-bullet-default-color);
    }
    .swiper-pagination-bullet-active {
      background: var(--main-content-carousel-bullet-active-color);
    }

    .swiper-pagination {
      margin-top: 2em;
      position: relative;
    }
  }
  &:not(.pagination-outside) {
    .swiper-pagination-bullet {
      height: $swiper-bullet-size;
      width: $swiper-bullet-size;
      cursor: pointer;
      margin: 0em 0.5em;
    }
    .swiper-pagination-bullets {
      bottom: 2rem;
    }
    .swiper-pagination-bullet {
      @include transition(opacity, 0.3s);
      &:hover {
        background: $white;
        opacity: 1;
      }
    }
    .swiper-pagination-bullet,
    .swiper-pagination-bullet-active {
      background: $swiper-bullet-active-color;
    }
    .swiper-pagination {
      //hide swiper pagination on lg screens and up
      @include media-breakpoint-up(lg) {
        @include transition(opacity, 0.3s);
        opacity: 0;
      }
    }
    &:hover {
      .swiper-pagination {
        @include media-breakpoint-up(lg) {
          opacity: 1;
        }
      }
    }
  }
  .swiper-pagination {
    .swiper-pagination-bullet:only-child {
      display: none;
    }
  }

  .swiper-container {
    width: 100%;
  }

  .ssr-mode {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .swiper-slide {

    }
  }
}
</style>
